import * as elements from './elements.js';

// Theme animation with Green Sock

// Import GSAP
import { gsap } from 'gsap';

// Import GSAP ScrollTrigger plugin
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
import { MorphSVGPlugin } from "gsap/MorphSVGPlugin";
import { GSDevTools } from "gsap/GSDevTools";
gsap.registerPlugin(DrawSVGPlugin, MorphSVGPlugin, GSDevTools);

// Hide warning if target not find
if(!WP_DEBUG) gsap.config({ nullTargetWarn: false });

// MorphSVGPlugin.convertToPath("circle, rect, ellipse, line, polygon, polyline");
window.addEventListener('load', () => {

    const titleTimeline = gsap.timeline({repeat: 0})
    titleTimeline.fromTo(elements.title1, 1, {opacity: 0, y: -60}, {opacity: 1, y: 0}, '>+=1.3');
    titleTimeline.fromTo(elements.title2, 1, {opacity: 0, y: -30}, {opacity: 1, y: 0});

    const coverTimeline = gsap.timeline({repeat: 0})
    // GSDevTools.create({animation: coverTimeline, globalSync: true});
    // Create desktop /cogs / 2 born / phone
    coverTimeline.fromTo(elements.desktop, 0.8, {opacity: 0, x: -650, y: 550}, {opacity: 1, x: 0, y: 0});

    coverTimeline.fromTo(elements.cogsLarge, 0.5, {scaleY:0, opacity:0, transformOrigin:"bottom"},{scaleY:1, opacity:1});
    coverTimeline.fromTo(elements.cogsSmallOne, 0.5, {scaleY:0, opacity:0, transformOrigin:"bottom"},{scaleY:1, opacity:1}, '<+=0.3');
    coverTimeline.fromTo(elements.cogsSmallTwo, 0.5, {scaleY:0, opacity:0, transformOrigin:"bottom"},{scaleY:1, opacity:1}, '<+=0.3');

    coverTimeline.fromTo(elements.bornLeft, 1.3, {scaleY:0, opacity:0, transformOrigin:"bottom"}, {scaleY:1, opacity:1}, '<-=0.7' );
    coverTimeline.fromTo(elements.bornRight, 1.3, {scaleY:0, opacity:0, transformOrigin:"bottom"}, {scaleY:1, opacity:1}, '<-=0.2' );
    coverTimeline.from(elements.phone, 1, {opacity: 0, scale:0.7}, {opacity: 1, scale:1},'<+=0.2');


    // Create line cogs / line phone / create box / create wifi icon
    coverTimeline.fromTo(elements.lineCogsRight, 1.5, {drawSVG:"0%"}, {drawSVG:"-100%"});
    coverTimeline.fromTo(elements.lineCogsBottom, 1.5, {drawSVG:"0%"}, {drawSVG:"100%"}, '<');

    coverTimeline.fromTo(elements.lineUnderPhoneTop, 1.5, {drawSVG:"0%"}, {drawSVG:"100%"}, '<');
    coverTimeline.fromTo(elements.lineUnderPhoneRight, 1.5, {drawSVG:"0%"}, {drawSVG:"-100%"}, '<');
    coverTimeline.fromTo(elements.lineUnderPhoneLeft, 1.5, {drawSVG:"0%"}, {drawSVG:"-100%"}, '<');
    coverTimeline.fromTo(elements.lineUnderPhoneBottom, 1.5, {drawSVG:"50% 50%"}, {drawSVG:"0% 100%"}, '<');

    coverTimeline.from(elements.box, 1, {opacity: 0},'-=0.2');
    coverTimeline.from(elements.wifiRed, {opacity:0, y: 50, stagger: 0.1}, '<+=0.3');
    coverTimeline.from(elements.wifiBlue, {opacity:0, y: 50, stagger: 0.1}, '<');

     // Create / line cogs to born / round cogs and phone
    coverTimeline.fromTo(elements.roundCogs, 1, {fill:"none"}, {fill:"white"},'-=1.5');
    coverTimeline.fromTo(elements.lineRoundPhone, 1, {fill:"none"}, {fill:"white"},'<');

    coverTimeline.fromTo(elements.linePayment, 1, {drawSVG:"0%"}, {drawSVG:"-100%"});
    coverTimeline.fromTo(elements.lineBorn, 1.5, {drawSVG:"0%"}, {drawSVG:"100%"}, '<');

    // Create screen / Display rect
    coverTimeline.from(elements.screens, 0.8, {opacity:0, y: 50, stagger: 0.1},'-=5.3');
    coverTimeline.from(elements.screenOneRect, {opacity:0, y: 50, stagger: 0.1}, '-=4.0');
    coverTimeline.from(elements.screenTwoRect, {opacity:0, y: 50, stagger: 0.1}, '-=4.0');
    coverTimeline.from(elements.screenThreeRect, {opacity:0, y: 50}, '-=4.0');

    // Create rect phone
    coverTimeline.from(elements.phoneRectBottom, {opacity:0, y: 50, stagger: 0.1}, '-=4.8');
    coverTimeline.from(elements.phoneRectTopPoly, {opacity:0, y: 50, stagger: 0.1}, '-=4.8');
    coverTimeline.from(elements.phoneRectTopPath, {opacity:0, y: 50, stagger: 0.1}, '-=4.2');

    // Create rect born
    coverTimeline.from(elements.bornRightSquare, {opacity:0, y: 50, stagger: 0.1}, '-=3.6');
    coverTimeline.from(elements.bornLeftSquare, {opacity:0, y: 50, stagger: 0.1}, '-=3.6');
    coverTimeline.from(elements.bornLeftText, {opacity:0, y: -50, stagger: 0.1}, '-=3.2');

    // Create chart
    coverTimeline.fromTo(elements.ChartFour, 1.2, {scaleY:0, opacity:0, transformOrigin:"bottom"},{scaleY:1, opacity:1}, '<' );
    coverTimeline.fromTo(elements.ChartThree, 1.2, {scaleY:0, opacity:0, transformOrigin:"bottom"},{scaleY:1, opacity:1}, '<+=0.3');
    coverTimeline.fromTo(elements.ChartTwo, 1.2, {scaleY:0, opacity:0, transformOrigin:"bottom"},{scaleY:1, opacity:1},'<+=0.3');
    coverTimeline.fromTo(elements.ChartOne, 1.2, {scaleY:0, opacity:0, transformOrigin:"bottom"},{scaleY:1, opacity:1},'<+=0.3');

    // Create born
    coverTimeline.fromTo(elements.bornPayment, 1, {scaleY:0, opacity:0, transformOrigin:"bottom"},{scaleY:1, opacity:1}, '-=1.48');

    // Create people
    coverTimeline.from(elements.men, 0.5, {opacity:0});
    coverTimeline.from(elements.woman, 0.5, {opacity:0}, '<');
})
